<template>
    <form v-if="migrateList.length"
          @submit.prevent="onSubmit"
          novalidate>
        <div class="modal-main">
            <h3>Migrate Children</h3>
            <select-box label="Migrate to"
                        :data-list="migrateList"
                        :format-callback="item => item.name"
                        @selected="onSelect">
            </select-box>
        </div>
        <div class="form-footer">
            <button class="primary-btn btn-center"
                    :disabled="!formValid || formPristine || !form.newId"
                    v-spinner="isLoading">
                Submit
            </button>
        </div>
    </form>
    <div v-else
         :style="{ height: '85%' }"
         class="not-found my-0 mx-4 text-center">
        <img src="../../assets/img/empty.png"
             :style="{ height: '250px', marginBottom: '25px' }"
        >
        Oh no! You haven't another active options.
    </div>
</template>

<script>
    import { mapGetters, mapActions } from 'vuex';
    import { FormMixin } from '@/mixins/FormMixin';
    import SpinnerDirective from '@/directives/SpinnerDirective';

    export default {
        name: 'MigrateChildrenModal',
        components: {
            SelectBox: () => import('@/components/controls/SelectBox')
        },
        directives: { SpinnerDirective },
        mixins: [FormMixin],
        data() {
            return {
                migrateListData: [],
                form: {
                    oldId: null,
                    newId: null
                }
            }
        },
        props: {
            getCallback: {
                type: Function,
                required: true
            },
            submitCallback: {
                type: Function,
                required: true
            }
        },
        computed: {
            ...mapGetters({
                schoolId: 'schoolId',
                selectedId: 'selectedId',
                selected: 'selected',
                isLoading: 'isLoading',
            }),

            migrateList() {
                return this.migrateListData.length
                    ? this.migrateListData.filter(i => i.id !== this.form.oldId)
                    : [];
            }
        },
        methods: {
            ...mapActions([
                'createSuccessNotification',
                'resetSelectedItems',
                'resetSelectedIdItem',
                'showSpinner',
                'hideSpinner'
            ]),
            async getMigrateList() {
                const { data } = await this.getCallback(this.schoolId);
                this.migrateListData = data;
            },
            onSelect(migrateToItem) {
                if (migrateToItem) {
                    this.form.newId = migrateToItem.id;
                }
            },
            onSubmit() {
                if (!this.isLoading) {
                    this.$validator.validate().then(valid => {
                        if (valid) {
                            this.showSpinner();
                            this.submitCallback({
                                oldIds: this.form.oldId ? [this.form.oldId] : this.selected,
                                newId: this.form.newId
                            }).then(() => {
                                this.hideSpinner();
                                const oldItem = this.migrateListData.find(i => i.id === this.selectedId);
                                const newItem = this.migrateListData.find(i => i.id === this.form.newId);
                                this.selectedId && oldItem
                                    ? this.createSuccessNotification(`You have successfully migrated children from ${oldItem.name} to ${newItem.name}`)
                                    : this.createSuccessNotification(`You have successfully migrated children to ${newItem.name}`);
                                this.selected.length && this.resetSelectedItems();
                            })
                        }
                    });
                }
            }
        },
        created() {
            if (this.selectedId) {
                this.form.oldId = this.selectedId;
            }
            this.getMigrateList();
        },
        destroyed() {
            if (this.selectedId) {
                this.form.oldId = null;
                this.resetSelectedIdItem();
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/modals/MigrateChildrenModal.vue